<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col>
                <b-card header="Latest albums" class="text-center block-header">
                    <b-spinner class="align-middle text-center text-info" v-if="mostRecentAlbumListLoadStatus == 1"></b-spinner>
                    <p v-else-if="mostRecentAlbumListLoadStatus == 3">Error loading data</p>
                    <b-row v-else-if="mostRecentAlbumListLoadStatus == 2">
                        <template v-for="mostRecentAlbum in mostRecentAlbumList">
                            <b-col sm="6" md="4" lg="3" xl="2" class="mb-1 mt-1">
                                <abbr :title="mostRecentAlbum.english_title">
                                    <b-card show-footer no-body class="mb-0 zoom cursor-pointer" v-on:click="$router.push({ name: 'AlbumDetails', params: { id: mostRecentAlbum.id } })">
                                        <b-card-body class="text-center no-padding">
                                            <img v-if="mostRecentAlbum.cover_art" :src="'../storage/images/cover_arts/' + mostRecentAlbum.cover_art" style="width: 100%; height: 182px; object-fit: cover;" />
                                            <img v-else src="images/default-album.png" style="width: 100%; height: 182px; object-fit: cover;" />
                                        </b-card-body>
                                        <div slot="footer" style="font-size: 0.7rem" class="text-center crop-text">{{ mostRecentAlbum.english_title }}</div>
                                    </b-card>
                                </abbr>
                            </b-col>
                        </template>
                    </b-row>
                    <nav v-if="mostRecentAlbumListLoadStatus == 2" class="ml-3 mb-1">
                        <b-pagination
                        v-model="mostRecentAlbumListPagination.current_page"
                        :total-rows="mostRecentAlbumListPagination.total"
                        :per-page="mostRecentAlbumListPagination.per_page"
                        class="mb-0 mt-1"
                        @input="changePage()"
                        >
                        </b-pagination>
                    </nav>
                </b-card>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-card header="Most listened albums" class="text-center block-header">
                    <b-row>
                        <template v-for="index in 12">
                            <b-col sm="6" md="4" lg="3" xl="2" class="mb-1 mt-1">
                                <b-card show-footer no-body class="mb-0">
                                    <b-card-body class="text-center no-padding">
                                        <img src="images/default-album.png" style="width: 100%; height: 182px; object-fit: cover;" />
                                    </b-card-body>
                                    <div slot="footer" style="font-size: 0.7rem" class="text-center">To be updated...</div>
                                </b-card>
                            </b-col>
                        </template>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-card header="Most liked albums" class="text-center block-header">
                    <b-row>
                        <template v-for="index in 12">
                            <b-col sm="6" md="4" lg="3" xl="2" class="mb-1 mt-1">
                                <b-card show-footer no-body class="mb-0">
                                    <b-card-body class="text-center no-padding">
                                        <img src="images/default-album.png" style="width: 100%; height: 182px; object-fit: cover;" />
                                    </b-card-body>
                                    <div slot="footer" style="font-size: 0.7rem" class="text-center">To be updated...</div>
                                </b-card>
                            </b-col>
                        </template>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name      : 'Index',
    created () {
        let data = {'page': 1, 'perPage': 12}
        this.$store.dispatch('album/getMostRecentAlbumList', data)
    },
    methods: {
        changePage(){
            let data = {'page': this.mostRecentAlbumListPagination.current_page, 'perPage': this.mostRecentAlbumListPagination.per_page}
            this.$store.dispatch('album/getMostRecentAlbumList', data)
        },
    },
    computed: {
        mostRecentAlbumList(){
            return this.$store.get('album/mostRecentAlbumList');
        },
        mostRecentAlbumListLoadStatus(){
            return this.$store.get('album/mostRecentAlbumListLoadStatus');
        },
        mostRecentAlbumListPagination(){
            return this.$store.get('album/mostRecentAlbumListPagination');
        },
    },
}
</script>

<style>
.block-header .card-header {
    text-align: left;
}
</style>
